// @mui
import { Box } from "@mui/material"
import type { BoxProps } from "@mui/material"
import { forwardRef, useContext } from "react"
import { Helmet } from "react-helmet-async"
import { useTranslation } from "react-i18next"

import { DomainContext } from "@/routes/providers/originals"

import { APP_NAME, APP_NAME_ORIGINALS } from "../config"

// ----------------------------------------------------------------------

const Page = forwardRef(
  (
    {
      children,
      title = "",
      meta,
      ...other
    }: {
      children: React.ReactNode
      title?: string
      meta?: React.ReactNode
    } & BoxProps,
    ref
  ) => {
    const { isOriginals } = useContext(DomainContext)
    const { t } = useTranslation()

    return (
      <>
        <Helmet>
          <title>{`${title} | ${t(isOriginals ? APP_NAME_ORIGINALS : APP_NAME)}`}</title>
          {meta}
        </Helmet>

        <Box ref={ref} sx={{ overflowX: "clip" }} {...other}>
          {children}
        </Box>
      </>
    )
  }
)

export default Page
